function roundToTwo(num: number) {
  if (num && typeof num === "number") {
    return (num * 100) / 100;
  } else {
    return 0;
  }
}

const getServiceTypeKey = (service: any) =>
  String(service?.type || service?.service_name || service?.typeName || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/[,_-]+/g, "");

export const estimateValidateForm = (
  estimateForm: any,
  isCostSection?: boolean,
  screenType?: any
) => {
  let isError = false;
  // check service section
  const localError: any = {};
  estimateForm?.services?.map((service: any, index: any) => {
    if (
      service?.price ||
      service?.isAccepted ||
      getServiceTypeKey(service) === "removal"
    ) {
      if (!(!service?.typeName && !service?.description && !service?.price)) {
        if (
          !(
            service?.typeName &&
            service?.description &&
            (service?.price || service?.price === 0)
          )
        ) {
          isError = true;
          if (localError?.services) {
            localError.services[index] = true;
          } else {
            localError.services = { [index]: true };
          }
        }
      }
    }
  });

  // Validate Costs (Only if isCostSection is true)
  if (isCostSection && screenType === "quotation") {
    estimateForm?.services?.map((cost: any, index: any) => {
      if (
        !(
          !cost?.driverQty &&
          !cost?.porterQty &&
          !cost?.packerQty &&
          !cost?.vehicleQty &&
          !cost?.vehicleTypeId &&
          !cost?.wageCharge &&
          !cost?.fuelCharge
        )
      ) {
        if (
          !(
            cost?.driverQty &&
            cost?.porterQty &&
            cost?.packerQty &&
            cost?.vehicleQty &&
            cost?.vehicleTypeId &&
            cost?.wageCharge &&
            cost?.fuelCharge
          )
        ) {
          isError = true;
          if (localError?.services) {
            localError.services[index] = true;
          } else {
            localError.services = { [index]: true };
          }
        }
      }
    });
  }

  estimateForm?.materials?.map((material: any, index: any) => {
    if (
      !(
        material?.surveyedQty !== null &&
        material?.surveyedQty !== "" &&
        material?.chargeQty !== null &&
        material?.chargeQty !== "" &&
        material?.price !== null &&
        material?.price !== "" &&
        material?.total !== null &&
        material?.total !== "" &&
        material?.volume !== null &&
        material?.volume !== "" &&
        material?.cost !== null &&
        material?.cost !== ""
      )
    ) {
      isError = true;
      if (localError?.materials) {
        localError.materials[index] = true;
      } else {
        localError.materials = { [index]: true };
      }
    }
  });

  estimateForm?.ancillaries?.map((ancillarie: any, index: any) => {
    if (ancillarie?.isChargeable) {
      if (
        !(
          ancillarie?.charge !== null &&
          ancillarie?.charge !== "" &&
          ancillarie?.name !== null &&
          ancillarie?.name !== ""
        )
      ) {
        isError = true;
        if (localError?.ancillaries) {
          localError.ancillaries[index] = true;
        } else {
          localError.ancillaries = { [index]: true };
        }
      }
    } else if (ancillarie?.charge !== null && ancillarie?.charge !== "") {
      if (!(ancillarie?.name !== null && ancillarie?.name !== "")) {
        isError = true;
        if (localError?.ancillaries) {
          localError.ancillaries[index] = true;
        } else {
          localError.ancillaries = { [index]: true };
        }
      }
    }
  });

  if (!estimateForm?.costTotal && isCostSection && screenType === "quotation") {
    isError = true;
    localError.costTotal = true;
  }

  if (!estimateForm?.quoteTotal) {
    isError = true;
    localError.quoteTotal = true;
  }

  // if(!estimateForm?.quoteExpiresOn && screenType ==='quotation'){
  //   isError = true;
  //   localError.quoteExpiresOn = true;
  // }

  return { isError, localError };
};

export const getTotal = (column: any, formData: any) => {
  const formRef = formData;
  let total: number = 0;
  switch (column) {
    case "total":
      formRef?.materials?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.total || 0));
      });
      break;
    case "volume":
      formRef?.materials?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.volume || 0));
      });
      break;
    case "cost":
      formRef?.materials?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.cost || 0));
      });
      break;
    case "ancillaries":
      formRef?.ancillaries?.map((cost: any) => {
        // Only add charge if isChargeable is true
        if (cost?.isChargeable) {
          total = roundToTwo(total + Number(cost?.charge || 0));
        }
      });
      break;
    case "wages":
      formRef?.services?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.wageCharge || 0));
      });
      break;
    case "costsCost":
      formRef?.services?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.fuelCharge || 0));
      });
      break;
    case "serivesCost":
      formRef?.services?.map((service: any) => {
        total = roundToTwo(total + Number(service?.price || 0));
      });
      break;
    default:
      total = 0;
  }
  return total;
};

export const estimateChangeAction = (
  event: any,
  section: any,
  index: any,
  valueFormat: any,
  estimateForm: any,
  vehicles: any
) => {
  const { id, value } = event.target;

  let formClone: any = {};
  // Handle generalInfo updates properly
  if (id === "materialPriceChargeable" || id === "vatIncluded") {
    formClone = {
      ...estimateForm,
      [id]: event?.target?.checked,
    };
  } else if (
    id === "quoteExpiresOn" ||
    id === "notes" ||
    id === "paymentMethod" ||
    id === "insurancePercentage" ||
    id === "insuranceAmount" ||
    id === "insuranceType" ||
    id === "contentValue"
  ) {
    formClone = {
      ...estimateForm,
      [id]: valueFormat === "number" ? (value ? Number(value) : value) : value,
    };
  } else {
    formClone = {
      ...estimateForm,
      [section]: [
        ...estimateForm[section]?.map((ele: any, i: any) => {
          let extraFields: any = {};
          if (i === index) {
            switch (section) {
              case "materials":
                const chargeQty = id === "chargeQty" ? value : ele?.chargeQty;
                const price = id === "price" ? value : ele?.price;
                const surveyedQty =
                  id === "surveyedQty" ? value : ele?.surveyedQty;
                if (chargeQty && price) {
                  extraFields.total = roundToTwo(
                    Number(chargeQty) * Number(price)
                  );
                } else {
                  extraFields.total = chargeQty === 0 || price === 0 ? 0 : "";
                }
                if (surveyedQty && price) {
                  extraFields.cost = roundToTwo(
                    Number(surveyedQty) * Number(price)
                  );
                } else {
                  extraFields.cost = surveyedQty === 0 || price === 0 ? 0 : "";
                }
                break;
              case "services":
                if (id === "vehicleTypeId") {
                  const findVehicle = vehicles.find(
                    (ele: any) => ele?.type_id === value
                  );
                  if (findVehicle && findVehicle?.count) {
                    extraFields.vehicleQty = findVehicle?.count;
                  } else {
                    extraFields.vehicleQty = 0;
                  }
                }
                break;
              default:
                extraFields = {};
            }
          }
          return i !== index
            ? ele
            : {
                ...ele,
                // [id]: valueFormat === 'number' ? value ?
                //   (
                //     value?.[value?.length-1] === "." ||
                //     (value?.[value?.length-2] === "." && value?.[value?.length-1] === "0")
                //   ) ? value : Number(value) :
                //   value : id === "isChargeable" ? event?.target?.checked : value,
                [id]:
                  valueFormat === "number" && value
                    ? Number(value)
                    : valueFormat === "price"
                    ? value
                    : id === "isChargeable"
                    ? event?.target?.checked
                    : value,
                ...extraFields,
              };
        }),
      ],
    };
  }
  formClone.services = formClone?.services?.map((ele: any, idx: any) => {
    return {
      ...ele,
      wageCharge: roundToTwo(
        Number(ele?.driverQty) * Number(formClone?.generalInfo?.driverWage) +
          Number(ele?.porterQty) * Number(formClone?.generalInfo?.porterWage) +
          Number(ele?.packerQty) * Number(formClone?.generalInfo?.packerWage)
      ),
    };
  });

  if (
    id === "insurancePercentage" &&
    formClone?.services?.[0]?.price
  ) {
    if(formClone?.insurancePercentage > 0){
      formClone = {
        ...formClone,
        insuranceAmount: roundToTwo(
          (parseFloat(formClone?.insurancePercentage) / 100) *
            parseFloat(formClone?.services?.[0]?.price)
        ),
      };
    }else {
      formClone = {
        ...formClone,
        insuranceAmount: 0,
      };
    }
  } else if (
    id === "insuranceAmount" &&
    formClone?.services?.[0]?.price
  ) {
if(formClone?.insuranceAmount > 0){
  formClone = {
    ...formClone,
    insurancePercentage: roundToTwo(
      (parseFloat(formClone?.insuranceAmount) /
        parseFloat(formClone?.services?.[0]?.price)) *
        100
    ),
  };
}else{
  formClone = {
    ...formClone,
    insurancePercentage: 0,
  };
}
  } else if (
    getServiceTypeKey(formClone?.services?.[0]) === "removal" &&
    formClone?.services?.[0]?.price &&
    formClone?.insurancePercentage &&
    formClone?.insurancePercentage > 0 
  ) {
    const insuranceAmount = roundToTwo(
      (parseFloat(formClone.insurancePercentage) / 100) *
        parseFloat(formClone.services[0].price)
    );

    const insurancePercentage = roundToTwo(
      (insuranceAmount / parseFloat(formClone.services[0].price)) * 100
    );

    formClone = {
      ...formClone,
      insuranceAmount,
      insurancePercentage,
    };
  } else {
    if (formClone) {
      formClone = {
        ...formClone,
        // insurancePercentage: 0,
        insuranceAmount: 0,
      };
    }
  }
  
  if (formClone?.materialPriceChargeable) {
    formClone.quoteTotal = roundToTwo(
      getTotal("total", formClone) +
        getTotal("serivesCost", formClone) +
        parseFloat(formClone?.insuranceAmount || 0)
    );
  } else {
    formClone.quoteTotal = roundToTwo(
      getTotal("serivesCost", formClone) + parseFloat(formClone?.insuranceAmount || 0)
    );
  }
  formClone.costTotal = roundToTwo(
    getTotal("costsCost", formClone) +
      getTotal("wages", formClone) +
      getTotal("cost", formClone) +
      getTotal("ancillaries", formClone)
  );

  return { estimateData: formClone };
};
